import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgByggforsk = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	x: "0px",
	y: "0px",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "byggforsk-symbol" }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#000000;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M12.837 7.6v9.4l-12.837-0.038v-9.55c1.988-2.412 4.2-5.012 6.25-7.412v0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M13.713 0l6.287 7.113v9.875l-3.75-0.038v-9.35l-6.4-7.6h3.862z"
		})
	]
});
export default SvgByggforsk;
